/**
 * ghostHunter plugin config and init
 */

(function(window, document) {
  var GH_search = $(".gh-search-field").ghostHunter({
    results: "#gh-results",
    result_template: "<a id='gh-{{ref}}' class='gh-search-item' href='{{link}}'><h4 class='gh-search-pubtitle'>{{title}}</h4><p class='gh-search-pubdate'>{{pubDate}}</p></a>",
		info_template: "<p class='gh-results-info'>{{amount}} posts encontrados</p>",
    includebodysearch: true,
    displaySearchInfo: true,
    onKeyUp: true
  });
  // interaction
  $('.gh-search-field').on('click', function(e) {
    $('.gh-search-wrapper').show(400)
  });
  $('.gh-search-close').on('click', function(e) {
    $('.gh-search-wrapper').hide(400)
    GH_search.clear()
  });
  $('#gh-search-field-mobile').on('keyup', function(event) {
    $('#gh-search-field').prop('value', event.target.value);
    $('#gh-search-field').trigger('keyup');
  });
})(window, document);
